import { ParsedUrlQuery } from 'querystring';
import { TimePreset } from '../../../schema/hannibal/types.generated';
import { GenderChoice } from './GenderChoice';
import { LocationChoice } from './LocationChoice';
import { TopicChoice } from './TopicChoice';
import { VaccineType } from './VaccineChoice';

export enum SearchFlags {
  TELEHEALTH = 'telehealth',
}

export type SearchFlag = 'telehealth';

export type SearchDatePreset = 'Today' | 'Tomorrow' | 'Next7Days' | 'NextAvailable';

export const isSearchDateRange = (date: SearchDate | undefined): date is SearchDateRange =>
  date !== undefined && date !== 'Today' && date !== 'Tomorrow' && date !== 'Next7Days';

export type SearchDateRange = { start: string; end?: string };

export type SearchDate = SearchDateRange | SearchDatePreset;

export interface FilterChoice {
  acceptsNewPatients?: boolean;
  alwaysShowFilters?: boolean;
  extraQuery?: ParsedUrlQuery;
  flag?: SearchFlag;
  fluVaxAppointmentType?: boolean;
  gender?: GenderChoice;
  governmentScheme?: string;
  hicaps?: boolean;
  hideTeleAggregators?: boolean;
  insurance?: string;
  insuranceProgram?: string;
  language?: string;
  location?: LocationChoice;
  onlineAppointments?: { date?: SearchDate; time?: TimePreset };
  paymentMethod?: string;
  pricingAvailable?: boolean;
  specialOffer?: boolean;
  text?: string;
  topic?: TopicChoice;
  vaccineType?: VaccineType | string;
}

export const SPECIALTY_GENERAL_PRACTICE = 'GP';

export const SPECIALTY_DENTIST = 'Dentist';

export const SPECIALTY_FLU_VACCINATIONS = 'Flu Vaccinations';

export const COVID_19_FLU_VACCINATIONS = 'Covid-19 Vaccinations';

export const COVID_19_VACCINATIONS = 'COVID-19 Vaccinations';
